import { z } from 'my-zod'
import { riderModel } from './rider-model'

export const additionalRider = riderModel.pick({ id: true, guestType: true }).augment({
  email: z.string().nullable(),
  firstName: z.string().max(50),
  lastName: z.string().max(50)
})

export type additionalRider = z.infer<typeof additionalRider>

export const legacyAdditionalRider = riderModel.pick({ id: true }).augment({
  isMinor: z.boolean(), // instead of guestType, mobile app don't know about this enum
  email: z.string().nullish(),
  firstName: z.string().max(50),
  lastName: z.string().max(50)
})

export type legacyAdditionalRider = z.infer<typeof legacyAdditionalRider>
